<span *ngIf="inContainer; else standAlone" [style.--order]="order" class="{{inputContainerClass}}
  {{animation}}">
  <ng-container *ngTemplateOutlet="fieldTpl"></ng-container>
</span>

<ng-template #standAlone>
  <ng-container *ngTemplateOutlet="fieldTpl"></ng-container>
</ng-template>

<ng-template #fieldTpl>
  <span class="d-inline-flex align-items-center">
    <!-- "range" | "checkbox" | "file" | "url" -->
    <ng-container *ngIf="type == 'toggle'">
       <span class="d-inline-flex align-items-center ">
          <ng-container *ngTemplateOutlet="labelTpl"></ng-container>
            <mat-slide-toggle (change)="onChange($event.checked)" [(ngModel)]="value"
                              class="padding-1 ps-2 top--3 pe-2">
            </mat-slide-toggle>
        </span>
    </ng-container>

    <ng-container *ngIf="type == 'radio'">
      <ng-container *ngTemplateOutlet="labelTpl"></ng-container>
      <mat-radio-group (change)="onChange($event.value)" [(ngModel)]="value" class="pe-2">
        <mat-radio-button *ngFor="let option of options" [value]="option">
          <span class="pe-2">{{ option | camelToTitleCase | removeUnderscore }} </span>
        </mat-radio-button>
      </mat-radio-group>
    </ng-container>

    <ng-container *ngIf="type == 'date'">
      <ng-container *ngTemplateOutlet="labelTpl"></ng-container>
      <mat-form-field [matTooltip]="toolTip" [style.max-width]="maxWidth"
                      appearance="fill"
                      class="custom-fill hide-arrow bg-none material-form padding-y-2">
        <span *ngIf="!value" class="very-faded" matPrefix> {{ placeholder | camelToTitleCase }}</span>
        <input (dateChange)="onChange($event.value)" [(ngModel)]="value"
               [matDatepicker]="date" matInput>
        <mat-datepicker-toggle [for]="date" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #date></mat-datepicker>
      </mat-form-field>
    </ng-container>

    <!-- Material inputs -->
    <ng-container *ngIf="type | valueIncludes :
      ['select','textarea','number','password','email','text','tel']">
      <ng-container *ngTemplateOutlet="labelTpl"></ng-container>
      <mat-form-field [matTooltip]="toolTip" [style.max-width]="maxWidth"
                      appearance="outline" class="{{dataFieldClass}} p-1">

        <span *ngIf="suffixIcon" class="pe-3" matSuffix>
          <ng-container *ngTemplateOutlet="iconTpl;
            context:{icon:suffixIcon, class:'icon-small position-relative'}"
          ></ng-container>
        </span>

        <ng-container *ngIf="type | valueIncludes : ['number','text','email','password','tel']">
          <input #input (change)="onChange(input.value)" [(ngModel)]="value" [placeholder]="placeholder"
                 [type]="type" autocomplete="off" matInput/>
        </ng-container>

        <ng-container *ngIf="type == 'textarea'">
          <textarea (change)="onChange($event)" [(ngModel)]="value" [placeholder]="placeholder"
                    autocomplete="off" matInput
          ></textarea>
        </ng-container>

        <ng-container *ngIf="type == 'select'">
          <mat-select (selectionChange)="onChange($event.value)" [(ngModel)]="value"
                      [multiple]="multiple" autocomplete="off" matInput>
            <mat-option *ngFor="let option of options" [value]="option">
              {{ option | camelToTitleCase | removeUnderscore }}
            </mat-option>
          </mat-select>
        </ng-container>

      </mat-form-field>
    </ng-container>

    <span (click)="onChange(value=undefined)" *ngIf="value && showCancel" [style.--order]="order+1"
          class="px-2 box-36 flex-inline-center ms-1 me-1 rounded-medium border-slightly-faded
      text-dark cursor-pointer  animate bg-slightly-faded-gradient d-flex align-items-center
      bg-hover-slightly-gradient border-on-hover{{animation}}" matTooltip="Clear">
      <mat-icon class="icon-small text-danger">close</mat-icon>
    </span>

  </span>
</ng-template>

<ng-template #labelTpl>
  <data-label
    (click)="labelClick.emit(true)"
    *ngIf="label || subLabel || icon"
    [active]="active"
    [icon]="icon"
    [inContainer]="false"
    [label]="label"
    [order]="order"
    [subLabel]="subLabel"
    [toolTip]="labelToolTip ?? toolTip"
  ></data-label>


</ng-template>

<ng-template #iconTpl let-class="class" let-icon="icon">
  <mat-icon *ngIf="(icon | iconType) == 'SVG'" [svgIcon]="icon" class="{{class}}"></mat-icon>
  <mat-icon *ngIf="(icon | iconType) == 'MATERIAL'" class="{{class}}"> {{icon}} </mat-icon>
</ng-template>



